module.exports = __webpack_public_path__ + "media/images/home/steps/newly_engaged-1aed49e5c698159452c9c0df10ce3520.png";